exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".menu{margin:0;padding:0;list-style:none;float:right;font-size:.8em}.menu-item{display:inline-block;margin-right:20px}.menu-item a{display:block;padding:4px 0}.menu-item:last-child{margin-right:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../~/sass-loader!./components/menu/menu.scss
 ** module id = 308
 ** module chunks = 0
 **/